import { Object3D } from "three";
class BindingInitializer {
    static _init = false;
    static edit3DObjectPrototype() {
        if (!this._init) {
            Object3D.prototype.bindProperty = function (property, getCallback, propertiesBound) {
                Binding.createProperty(property, this, getCallback, propertiesBound);
                return this;
            };
            Object3D.prototype.unbindProperty = function (property) {
                Binding.removeProperty(property, this);
                return this;
            };
        }
        this._init = true;
    }
}
export class Binding {
    static _propertiesBound = {};
    static _callbacks = {};
    static _boundModel;
    static init(modelToBind, modelToMerge) {
        if (this._boundModel) {
            console.error("Binding model already assigned.");
        }
        BindingInitializer.edit3DObjectPrototype();
        this.mergeNewModel(modelToBind, modelToMerge);
        for (const propertyName in modelToBind) {
            this._propertiesBound[propertyName] = [];
            this.generateBoundGetterAndSetter(modelToBind, propertyName);
        }
        this._boundModel = modelToBind;
    }
    static generateBoundGetterAndSetter(modelToBind, propertyName) {
        const privatePropertyName = `_${propertyName}`;
        modelToBind[privatePropertyName] = modelToBind[propertyName];
        Object.defineProperty(modelToBind, propertyName, {
            get: () => {
                return modelToBind[privatePropertyName];
            },
            set: (value) => {
                modelToBind[privatePropertyName] = value;
                Binding.executeAllPropertyBoundCallbacks(propertyName);
            }
        });
    }
    static executeAllPropertyBoundCallbacks(property) {
        if (this._boundModel) {
            const bindingArray = this._propertiesBound[property];
            if (bindingArray) {
                for (const bindingElement of bindingArray) {
                    this.executeCallback(bindingElement);
                }
            }
        }
        else {
            console.error("Binding must be initialized before used.");
        }
    }
    static executeCallback(bindingCallback) {
        bindingCallback.setValueCallback(bindingCallback.getValueCallback(this._boundModel));
    }
    static createCustom(name, getCallback, setCallback, propertiesBound) {
        if (this._callbacks[name]) {
            console.error("Cannot create binding. Name already exists.");
            return;
        }
        const bindingCallback = {
            setValueCallback: setCallback,
            getValueCallback: getCallback,
            propertiesBound: propertiesBound,
            name: name
        };
        this._callbacks[name] = bindingCallback;
        for (const propertyBound of propertiesBound) {
            this._propertiesBound[propertyBound].push(bindingCallback);
        }
        this.executeCallback(bindingCallback);
    }
    static removeCustom(name) {
        const bindingCallback = this._callbacks[name];
        if (bindingCallback) {
            for (const propName of bindingCallback.propertiesBound) {
                const prop = this._propertiesBound[propName];
                const index = prop.findIndex(x => x.name == name);
                if (index > -1) {
                    prop.splice(index, 1);
                }
            }
            delete this._callbacks[name];
        }
    }
    static createProperty(property, object3D, getCallback, propertiesBound) {
        const setCallback = (value) => { object3D[property] = value; };
        this.createCustom(`_selfGenerated_${object3D.id}.${property}`, getCallback, setCallback, propertiesBound); //todo dispose leave this event e avvisare che per i custom create non sarà possibile
    }
    static removeProperty(property, object3D) {
        this.removeCustom(`_selfGenerated_${object3D.id}.${property}`);
    }
    static unbindAll(object3D) {
        for (const callback in this._callbacks) {
            if (this._callbacks[callback].name.startsWith(`_selfGenerated_${object3D.id}.`)) {
                this.removeCustom(this._callbacks[callback].name);
            }
        }
    }
    static mergeNewModel(baseModel, modelToMerge) {
        if (modelToMerge) {
            for (const propertyName in modelToMerge) {
                if (baseModel[propertyName] === undefined) {
                    baseModel[propertyName] = modelToMerge[propertyName];
                }
            }
        }
    }
}
//# sourceMappingURL=Binding.js.map